import setCurrencyCookie from "@Currency/functions/setCurrencyCookie"

export default function saveInLocalStorage(currency: string) {
    localStorage.setItem('currency', currency);
    setCurrencyCookie(currency)
}